import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FiMenu, FiX, FiMail, FiPhone } from "react-icons/fi";
import { FaInstagram, FaYoutube, FaFacebookF, FaTwitter, FaWhatsapp } from "react-icons/fa";
import { useSite } from "../context/SiteContext";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/config";

// Fixed default nav links (always show)
const DEFAULT_NAV = [
  { title: "HOME", path: "/" },
  { title: "MENTAL HEALTH RESOURCES", path: "/mental-health-resources" },
  { title: "SELF-CARE", path: "/self-care" },
  { title: "KINDNESS SHOP", path: "/shop" },
  { title: "AUTHOR'S CORNER", path: "/author-corner" },
  { title: "EVENTS", path: "/events" },
  { title: "BLOG", path: "/blog" },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { settings } = useSite();
  const [extraLinks, setExtraLinks] = useState([]);

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "settings", "navigation"), (snap) => {
      if (snap.exists() && snap.data().header) {
        setExtraLinks(snap.data().header);
      }
    });
    return unsub;
  }, []);

  const navLinks = [
    ...DEFAULT_NAV,
    ...extraLinks.filter((l) => !DEFAULT_NAV.some((d) => d.path === l.path)),
  ];

  const socials = [
    { icon: <FaWhatsapp />, key: "whatsapp" },
    { icon: <FaTwitter />, key: "twitter" },
    { icon: <FaYoutube />, key: "youtube" },
    { icon: <FaInstagram />, key: "instagram" },
    { icon: <FaFacebookF />, key: "facebook" },
  ];

  return (
    <>
      {/* Top Pink Bar */}
      <div className="bg-[#e84fa5] text-white" style={{ fontFamily: "Open Sans, sans-serif" }}>
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="h-12 flex items-center justify-between">
            <div className="flex items-center text-[13px]">
              <div className="flex items-center gap-2">
                <FiMail size={14} />
                <span>{settings.email || "larsonk503@gmail.com"}</span>
              </div>
              <div className="mx-4 h-5 w-px bg-white/50" />
              <div className="flex items-center gap-2">
                <FiPhone size={14} />
                <span>{settings.phone || "12183041383"}</span>
              </div>
            </div>
            <div className="hidden md:flex items-center gap-4 text-[15px]">
              {socials.map((s) => (
                <a key={s.key} href={settings.social?.[s.key] || "#"} target="_blank" rel="noopener noreferrer"
                  className="hover:text-white/70 transition">{s.icon}</a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="h-[90px] flex items-center justify-between">
            <Link to="/">
              <img src={settings.logoLight || "/logo.svg"} alt="Simple Kindness" className="h-14 object-contain"
                onError={(e) => { e.target.style.display = "none"; }} />
            </Link>

            <nav className="hidden xl:flex items-center" style={{ fontFamily: "Montserrat, sans-serif" }}>
              {navLinks.map((item) => (
                <Link key={item.path} to={item.path}
                  className="px-[15px] text-[13px] font-bold uppercase text-black hover:text-[#e84fa5] transition whitespace-nowrap">
                  {item.title || item.label}
                </Link>
              ))}
            </nav>

            <button className="xl:hidden p-2" onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? <FiX size={26} /> : <FiMenu size={26} />}
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="xl:hidden bg-white border-t shadow-lg">
            {navLinks.map((item) => (
              <Link key={item.path} to={item.path} onClick={() => setMenuOpen(false)}
                className="block px-6 py-3.5 border-b text-[13px] font-bold uppercase hover:bg-pink-50 hover:text-[#e84fa5] transition">
                {item.title || item.label}
              </Link>
            ))}
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
